export default __webpack_public_path__ + "static/media/property.11f290e6.png";